import React, { useState } from 'react';
import { Network, Clock, Users } from 'lucide-react';
import OrgChartVisualization from './OrgChartVisualization';
import OrgChartPendingTable from './OrgChartPendingTable';
import { useHasPermission } from '../../store/hooks/useRbac';
import { PERMISSIONS } from '../../utils/rbac/permissions';
import { TabSelector } from '../common';
import type { TabItem } from '../common';

type TabType = 'chart' | 'pending';

const OrgChart: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('chart');
  const canManageApprovals = useHasPermission(PERMISSIONS.ORG_CHART_APPROVALS) || 
                             useHasPermission(PERMISSIONS.ORG_CHART_MANAGE) || 
                             useHasPermission(PERMISSIONS.EMPLOYEE_MANAGEMENT_MANAGE);

  const tabs: TabItem<TabType>[] = [
    { k: 'chart', label: 'Hierarchy View' },
    ...(canManageApprovals ? [{ k: 'pending' as const, label: 'Pending Requests' }] : [])
  ];

  return (
    <div className="p-4 sm:p-6 bg-slate-50 min-h-screen">
      <div className="max-w-full mx-auto">
        <div className="mb-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-slate-900">
              Organizational Chart
            </h1>
          </div>
        </div>

        {/* Tabs Container */}
        {tabs.length > 1 && (
          <div className="mb-6">
            <TabSelector
              active={activeTab}
              onChange={(tab) => setActiveTab(tab)}
              tabs={tabs}
            />
          </div>
        )}

        {activeTab === 'chart' ? (
          <div className={`bg-white rounded-2xl shadow-soft border border-slate-200 overflow-hidden w-full ${
            tabs.length > 1 ? 'h-[calc(100vh-300px)]' : 'h-[calc(100vh-220px)]'
          }`}>
            <OrgChartVisualization />
          </div>
        ) : (
          <OrgChartPendingTable />
        )}
      </div>
    </div>
  );
};

export default OrgChart;
